"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PublicRoutes = void 0;
var PublicRoutes;
(function (PublicRoutes) {
    PublicRoutes["ROOT"] = "/";
    PublicRoutes["DESCRIPTION"] = "/description";
    PublicRoutes["NOT_FOUND"] = "*";
    PublicRoutes["PAYMENT_ROUTE"] = "/pay";
    PublicRoutes["PAYMENT_ERROR_ROUTE"] = "/payment-error";
    PublicRoutes["PAYMENT_SUCCESS_ROUTE"] = "/payment-success";
    PublicRoutes["PAYMENT_IN_PROGRESS_ROUTE"] = "/payment-in-progress";
    PublicRoutes["SUCCESS_PAY"] = "/success-pay";
    PublicRoutes["IN_PROGRESS_PAY"] = "/in-progress-pay";
    PublicRoutes["FAILED_PAY"] = "/failed-pay";
    PublicRoutes["LOGIN"] = "/login";
    PublicRoutes["POLICY_BANNED"] = "/policy-banned";
})(PublicRoutes || (exports.PublicRoutes = PublicRoutes = {}));
